import script from "./ThankYou.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThankYou.vue?vue&type=script&setup=true&lang=ts"

import "./ThankYou.vue?vue&type=style&index=0&id=2d345875&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d345875"]])

export default __exports__